import { callService, niceCheck } from "@Views/utils/ServiceUtils";
import { getLanguage } from "@Views/utils/StringUtils";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

const Main = ({ msg, userInfo }: any) => {

    const history: any = useHistory();
    const [qstAnsList, setQstAnsList] = useState<any>([]);
    const [ntcList, setNtcList] = useState<any>([]);
    const langCd = getLanguage();

    let [selectAgePopupActive, setSelectAgePopupActive] = useState<boolean>(false);
    let [selectAge, setSelectAge] = useState<string>('A');


    const OSMBC05R01 = async () => {
        const res = await callService("OSMBC05R01", { pageNum: 1 });
        setQstAnsList(res['qstAnsList']);
    }

    const OSMBA05R01 = async () => {
        const res = await callService("OSMBA05R01", { pageNum: 1, langCd: langCd });
        setNtcList(res['ntcList']);
    }

    const AuthKeyApplyClick1 = () => {

        if (userInfo) {
            history.push('/AuthKeyApply');
        }
        else {
            setSelectAgePopupActive(true);
        }

    }

    const AuthKeyApplyClick2 = () => {

        if (selectAge === 'A') {
            niceCheck('/api/#/AuthKeyApply');
        }
        else if (selectAge === 'B') {

        }

    }

    const onClickRadioAge = (e: any) => {
        const selectedStdRadio: any = document.querySelector('input[name="radio2-1"]:checked');
        setSelectAge(selectedStdRadio['value']);
    }

    useEffect(() => {
        OSMBC05R01();
        OSMBA05R01();
    }, []);

    return (
        <>
            <div className={"modal fade" + (selectAgePopupActive ? ' show' : '')}>
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <strong className="modal-title"></strong>
                            <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setSelectAgePopupActive(false) }}>
                            </button>
                        </div>
                        <div className="modal-comp">
                            <div className="txt-con">
                                <div className="con-tit">
                                    <strong className="tit">알림</strong>
                                </div>
                                <div className="con-desc">
                                    <h4>이용자 구분 선택</h4>
                                    <p><br /></p>
                                    <div className="input-box">
                                        <div className="input-group" style={{ textAlign: 'left', paddingLeft: '10px' }}>
                                            <input type="radio" name="radio2-1" id="radio2-1" className="form-control" value="A" defaultChecked={true} onClick={onClickRadioAge} />
                                            <label htmlFor="radio2-1"><span>일반 이용자(만 14세 이상)</span></label>
                                        </div>
                                    </div>
                                    <p><br /></p>
                                    {selectAge === 'A' &&
                                        <p>회원가입을 위한 본인인증 절차를 진행합니다.</p>
                                    }
                                </div>
                                <div className="btn-wrap" style={{ "textAlign": "center" }}>
                                    <div className="form-group form-group-checkbox">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <div className="input-group">
                                                    <button type="button" className="btn btn-popup positive" onClick={() => { AuthKeyApplyClick2() }}>확인</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal-backdrop fade" + (selectAgePopupActive ? ' show' : '')}></div>

            <div className="wrap-body" tabIndex={-1} >
                <div className="wrap-body-content">
                    <div className="main-intro">
                        <div className="intro-message">
                            <div className="txt-box">
                                <h2 dangerouslySetInnerHTML={{ __html: msg['title'] }}></h2>
                                <p dangerouslySetInnerHTML={{ __html: msg['titleDesc'] }}></p>
                            </div>
                        </div>
                    </div>
                    <div className="main-board">
                        <div className="main-01">
                            <h3>{msg['siteManual']}</h3>
                            <ol className="main-01-ol clearfix">
                                <li>
                                    <div className="howTouse" dangerouslySetInnerHTML={{ __html: msg['siteManual1'] }}></div>
                                </li>
                                <li>
                                    <div style={{ cursor: "pointer" }} onClick={AuthKeyApplyClick1} className="howTouse" dangerouslySetInnerHTML={{ __html: msg['siteManual2'] }}></div>
                                </li>
                                <li>
                                    <div className="howTouse" dangerouslySetInnerHTML={{ __html: msg['siteManual3'] }}></div>
                                </li>
                                <li>
                                    <div className="howTouse" dangerouslySetInnerHTML={{ __html: msg['siteManual4'] }}></div>
                                </li>
                                <li>
                                    <div className="howTouse" dangerouslySetInnerHTML={{ __html: msg['siteManual5'] }}></div>
                                </li>
                            </ol>
                        </div>
                        <div className="main-02-03 clearfix">
                            <div className="box-02-03">
                                <div className="main-02">
                                    <h3>{msg['serviceIntroductionTitle']}</h3>
                                    <p>{msg['serviceIntroductionDesc']}</p>
                                    <Link to='/ServiceIntroduction' onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && history.push('/ServiceIntroduction')}>{msg['link']}</Link>
                                </div>
                            </div>
                            <div className="box-02-03">
                                <div className="main-03">
                                    <h3>{msg['serviceListTitle']}</h3>
                                    <p>{msg['serviceListDesc']}</p>
                                    <Link to='/ServiceUse/ServiceList' onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && history.push('/ServiceUse/ServiceList')}>{msg['link']}</Link>
                                </div>
                            </div>
                        </div>

                        <div className="main-04-05 clearfix">
                            <div className="box-04-05">
                                <div className="main-04 clearfix">
                                    <h3>{msg['qna']}</h3>
                                    <div className="table-02">
                                        <table>
                                            <tbody>
                                                {
                                                    qstAnsList.length > 0 && qstAnsList.map((qstAns: any, qstAnsIndex: number) => (
                                                        qstAnsIndex < 3 &&
                                                        <tr key={qstAnsIndex}>
                                                            <td><Link to={'/ParticipatoryCommunication/QNA/' + qstAns['qstAnsId']} onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && history.push('/ParticipatoryCommunication/QNA/' + qstAns['qstAnsId'])}>{qstAns['qstAnsTtlNm']}</Link></td>
                                                            <td><span className="date">{qstAns['zRegDtm']}</span></td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="more">
                                        <Link to='/ParticipatoryCommunication/QNA' onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && history.push('/ParticipatoryCommunication/QNA')}>{msg['more']}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="box-04-05">
                                <div className="main-05 clearfix">
                                    <h3>{msg['notice']}</h3>
                                    <div className="table-02">
                                        <table>
                                            <tbody>
                                                {
                                                    ntcList.length > 0 && ntcList.map((ntc: any, ntcIndex: number) => (
                                                        ntcIndex < 3 &&
                                                        <tr key={ntcIndex}>
                                                            <td><Link to={'/ParticipatoryCommunication/Notice/' + ntc['ntcId']} onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && history.push('/ParticipatoryCommunication/Notice/' + ntc['ntcId'])}>{ntc['ntcTtlNm']}</Link></td>
                                                            <td><span className="date">{ntc['zRegDtm']}</span></td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="more">
                                        <Link to='/ParticipatoryCommunication/Notice' onKeyUp={(e) => (e.code === 'Space' || e.key === 'Enter') && history.push('/ParticipatoryCommunication/Notice')}>{msg['more']}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Main;